import React, { useState, useEffect, useContext } from 'react';
import Header from '../../components/Header';
import MobileNavbar from '../../components/MobileNavbar';
import Sidebar from '../../components/Sidebar';
import './index.css';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Modal from '@mui/material/Modal';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { AuthContext } from '../../contexts/AuthContext';
import {
  get_themes,
  create_theme,
  update_theme,
  delete_theme,
} from '../../API/theme';
import toast from 'react-hot-toast';

export default function Theme() {
  const { authAxios, user, logout } = useContext(AuthContext);
  const [themes, setThemes] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editName, setEditName] = useState(null);
  const [editPrimaryBG, setEditPrimaryBG] = useState('#1c2038');
  const [editImgWrapBg, setEditImgWrapBg] = useState('#1c2038b0');
  const [editSecondaryBG, setEditSecondaryBG] = useState('#252b48');
  const [editTextWhite, setEditTextWhite] = useState('#fff');
  const [editTextGrey, setEditTextGrey] = useState('#bebebe');
  const [editPrimaryBoxShadow, setPrimaryBoxShadow] = useState('#14182b');
  const [editSecondaryBoxShadow, setSecondaryBoxShadow] = useState('#3c4071');
  const [editPrimaryBorderColor, setPrimaryBorderColor] = useState('#454d80');
  const [editBackDrop, setEditBackDrop] = useState('#252b48cf');
  const [editLightBlue, setEditLightBlue] = useState('#4fc8e9');
  const [editModal, setEditModal] = useState(false);

  const handleDeleteTheme = async (e) => {
    e.preventDefault();
    let res = await delete_theme(authAxios, selectedRow.id);
    if (res.status === 204) {
      toast.success('Deleted Successfully');
      setDeleteModal(false);
      await getThemes();
    } else {
      toast.error(Object.values(res.response.data)[0]);
    }
  };

  const handleCreateTheme = async (e) => {
    e.preventDefault();
    const payload = {
      name: editName,
      primary_BG: editPrimaryBG || '#1c2038',
      img_wrap_bg: editImgWrapBg || '#1c2038b0',
      secondary_BG: editSecondaryBG || '#252b48',
      text_white: editTextWhite || '#fff',
      text_grey: editTextGrey || '#bebebe',
      primary_box_shadow: editPrimaryBoxShadow || '#14182b',
      secondary_box_shadow: editSecondaryBoxShadow || '#3c4071',
      primary_border_color: editPrimaryBorderColor || '#454d80',
      back_drop: editBackDrop || '#252b48cf',
      light_blue: editLightBlue || '#4fc8e9',
    };
    let res = await create_theme(authAxios, payload);
    if (res.status === 201) {
      toast.success('Created Successfully');
      setEditModal(false);
      await getThemes();
    } else {
      toast.error(Object.values(res.response.data)[0]);
    }
  };

  const handleUpdateTheme = async (e) => {
    e.preventDefault();
    const payload = {
      id: selectedRow.id,
      name: editName,
      primary_BG: editPrimaryBG || '#1c2038',
      img_wrap_bg: editImgWrapBg || '#1c2038b0',
      secondary_BG: editSecondaryBG || '#252b48',
      text_white: editTextWhite || '#fff',
      text_grey: editTextGrey || '#bebebe',
      primary_box_shadow: editPrimaryBoxShadow || '#14182b',
      secondary_box_shadow: editSecondaryBoxShadow || '#3c4071',
      primary_border_color: editPrimaryBorderColor || '#454d80',
      back_drop: editBackDrop || '#252b48cf',
      light_blue: editLightBlue || '#4fc8e9',
    };
    let res = await update_theme(authAxios, payload, selectedRow.id);
    if (res.status === 200) {
      toast.success('Updated Successfully');
      setEditModal(false);
      setSelectedRow(null);
      await getThemes();
    } else {
      toast.error(Object.values(res.response.data)[0]);
    }
  };

  const getThemes = async () => {
    let res = await get_themes(authAxios);
    if (res.status === 200) {
      setThemes(res.data);
    } else {
      toast.error(Object.values(res.response.data)[0]);
    }
  };

  useEffect(() => {
    getThemes();
  }, []);

  return (
    <div className='dashboard page'>
      <Sidebar page='themes' />
      <div className='hero_content theme_content'>
        <MobileNavbar />
        <Header />
        <div className='pagewrapper'>
          <div className='booking_wrapper'>
            <div className='booking_header'>
              <h4>All Themes</h4>
              <div className='allUsers_header_actions'>
                <button onClick={() => setEditModal(true)}>Create Theme</button>
              </div>
            </div>
            <div className='allUsers_table'>
              <table>
                <thead>
                  <td>Theme Name</td>
                  <td>primary_BG</td>
                  <td>img_wrap_bg</td>
                  <td>secondary_BG</td>
                  <td>text_white</td>
                  <td>text_grey</td>
                  <td>Primary Shadow</td>
                  <td>Sec Shadow</td>
                  <td>Primary BorderColor</td>
                  <td>back_drop</td>
                  <td>light_blue</td>
                  <td className='table_actions'></td>
                </thead>
                {themes.map((theme) => (
                  <tr id={theme.id}>
                    <td>{theme.name}</td>
                    <td>{theme.primary_BG}</td>
                    <td>{theme.img_wrap_bg}</td>
                    <td>{theme.secondary_BG}</td>
                    <td>{theme.text_white}</td>
                    <td>{theme.text_grey}</td>
                    <td>{theme.primary_box_shadow}</td>
                    <td>{theme.secondary_box_shadow}</td>
                    <td>{theme.primary_border_color}</td>
                    <td>{theme.back_drop}</td>
                    <td>{theme.light_blue}</td>
                    <td className='table_actions'>
                      <button
                        onClick={() => {
                          setEditModal(true);
                          setSelectedRow(theme);
                          setEditName(theme.name);
                          setEditPrimaryBG(theme.primary_BG);
                          setEditImgWrapBg(theme.img_wrap_bg);
                          setEditSecondaryBG(theme.secondary_BG);
                          setEditTextWhite(theme.text_white);
                          setEditTextGrey(theme.text_grey);
                          setPrimaryBoxShadow(theme.primary_box_shadow);
                          setSecondaryBoxShadow(theme.secondary_box_shadow);
                          setPrimaryBorderColor(theme.primary_border_color);
                          setEditBackDrop(theme.back_drop);
                          setEditLightBlue(theme.light_blue);
                        }}
                      >
                        <svg
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M4.02717 11.75C4.05842 11.75 4.08967 11.7469 4.12092 11.7422L6.74905 11.2812C6.7803 11.275 6.80999 11.2609 6.83186 11.2375L13.4553 4.61406C13.4698 4.59961 13.4813 4.58244 13.4891 4.56354C13.497 4.54463 13.501 4.52437 13.501 4.50391C13.501 4.48344 13.497 4.46318 13.4891 4.44428C13.4813 4.42538 13.4698 4.40821 13.4553 4.39375L10.8584 1.79531C10.8287 1.76563 10.7897 1.75 10.7475 1.75C10.7053 1.75 10.6662 1.76563 10.6365 1.79531L4.01311 8.41875C3.98967 8.44219 3.97561 8.47031 3.96936 8.50156L3.50842 11.1297C3.49322 11.2134 3.49865 11.2995 3.52425 11.3807C3.54984 11.4618 3.59482 11.5355 3.6553 11.5953C3.75842 11.6953 3.88811 11.75 4.02717 11.75V11.75ZM5.0803 9.025L10.7475 3.35938L11.8928 4.50469L6.22561 10.1703L4.83655 10.4156L5.0803 9.025V9.025Z'
                            fill='white'
                          />
                          <path
                            d='M13.75 13.0625H2.25C1.97344 13.0625 1.75 13.2859 1.75 13.5625V14.125C1.75 14.1938 1.80625 14.25 1.875 14.25H14.125C14.1938 14.25 14.25 14.1938 14.25 14.125V13.5625C14.25 13.2859 14.0266 13.0625 13.75 13.0625Z'
                            fill='white'
                          />
                        </svg>
                        Edit
                      </button>
                      <button
                        onClick={() => {
                          setDeleteModal(true);
                          setSelectedRow(theme);
                        }}
                      >
                        <svg
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M9.2 3.2002C9.2 2.88194 9.07357 2.57671 8.84853 2.35167C8.62348 2.12662 8.31826 2.0002 8 2.0002C7.68174 2.0002 7.37652 2.12662 7.15147 2.35167C6.92643 2.57671 6.8 2.88194 6.8 3.2002H6C6 2.66976 6.21071 2.16105 6.58579 1.78598C6.96086 1.41091 7.46957 1.2002 8 1.2002C8.53043 1.2002 9.03914 1.41091 9.41421 1.78598C9.78929 2.16105 10 2.66976 10 3.2002H13.6C13.7061 3.2002 13.8078 3.24234 13.8828 3.31735C13.9579 3.39237 14 3.49411 14 3.6002C14 3.70628 13.9579 3.80802 13.8828 3.88304C13.8078 3.95805 13.7061 4.0002 13.6 4.0002H13.1568L12.12 12.9842C12.0749 13.3741 11.888 13.7338 11.5949 13.9949C11.3018 14.256 10.9229 14.4002 10.5304 14.4002H5.4696C5.07708 14.4002 4.69823 14.256 4.40513 13.9949C4.11204 13.7338 3.92514 13.3741 3.88 12.9842L2.8424 4.0002H2.4C2.30638 4.00023 2.21571 3.96742 2.14379 3.90748C2.07187 3.84755 2.02325 3.76429 2.0064 3.6722L2 3.6002C2 3.49411 2.04214 3.39237 2.11716 3.31735C2.19217 3.24234 2.29391 3.2002 2.4 3.2002H9.2ZM12.3504 4.0002H3.6488L4.6744 12.8922C4.69698 13.0872 4.79048 13.2671 4.93712 13.3977C5.08375 13.5282 5.27327 13.6003 5.4696 13.6002H10.5304C10.7266 13.6001 10.9159 13.528 11.0624 13.3974C11.2088 13.2669 11.3022 13.0871 11.3248 12.8922L12.3504 4.0002Z'
                            fill='white'
                          />
                          <path
                            d='M6.79844 6C6.99444 6 7.15844 6.124 7.19204 6.2872L7.19844 6.3504V11.2504C7.19844 11.4432 7.01924 11.6 6.79844 11.6C6.60244 11.6 6.43844 11.476 6.40484 11.3128L6.39844 11.2496V6.3512C6.39844 6.1576 6.57764 6.0008 6.79844 6.0008V6ZM9.19844 6C9.39444 6 9.55844 6.124 9.59204 6.2872L9.59844 6.3504V11.2504C9.59844 11.4432 9.41924 11.6 9.19844 11.6C9.00244 11.6 8.83844 11.476 8.80484 11.3128L8.79844 11.2496V6.3512C8.79844 6.1576 8.97764 6.0008 9.19844 6.0008V6Z'
                            fill='white'
                          />
                        </svg>
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </div>
          <Modal
            open={deleteModal}
            onClose={() => setDeleteModal(false)}
            aria-labelledby='conf_modal'
            aria-describedby='modal-modal-description'
          >
            <div className='confModal'>
              <svg
                width='110'
                height='110'
                viewBox='0 0 110 110'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>{' '}
              <br />
              <h4>Are You Sure?</h4>
              <p>
                Do you really want to delete this info. This process cannot be
                undo.
              </p>
              <div className='btns'>
                <button
                  onClick={() => setDeleteModal(false)}
                  className='secondary'
                >
                  Cancel
                </button>
                <button
                  className='primary'
                  onClick={(e) => handleDeleteTheme(e)}
                >
                  Delete
                </button>
              </div>
            </div>
          </Modal>
          <Modal
            open={editModal}
            // onClose={() => setEditModal(false)}
            aria-labelledby='conf_modal'
            aria-describedby='modal-modal-description'
            // BackdropProps={}
          >
            <div
              className='confModal edit_theme_modal'
              style={{ position: 'relative' }}
            >
              <div>
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 110 110'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  onClick={() => setEditModal(false)}
                  style={{
                    position: 'absolute',
                    width: '20px',
                    right: '20px',
                    top: '18px',
                    cursor: 'pointer',
                  }}
                >
                  <path
                    d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
              <br />
              <h4>Edit Theme</h4>
              <div className='info_wrapper'>
                <div className='info_row '>
                  <div className='field'>
                    Theme Name
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        className='airport_name'
                        labelId='size'
                        id='demo-simple-select'
                        value={editName}
                        label='Name'
                        onChange={(e) => setEditName(e.target.value)}
                      ></TextField>
                    </FormControl>
                  </div>
                </div>
                <div className='info_row '>
                  <div className='field'>
                    Img Wrap Bg
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        className='airport_name'
                        labelId='size'
                        type='color'
                        id='demo-simple-select'
                        value={editImgWrapBg}
                        onChange={(e) => setEditImgWrapBg(e.target.value)}
                      ></TextField>
                    </FormControl>
                  </div>
                  <div className='field'>
                    Secondary BG
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        className='airport_name'
                        labelId='size'
                        type='color'
                        id='demo-simple-select'
                        value={editSecondaryBG}
                        onChange={(e) => setEditSecondaryBG(e.target.value)}
                      ></TextField>
                    </FormControl>
                  </div>
                </div>
                <div className='info_row '>
                  <div className='field'>
                    Text White
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        className='airport_name'
                        labelId='size'
                        type='color'
                        id='demo-simple-select'
                        value={editTextWhite}
                        onChange={(e) => setEditTextWhite(e.target.value)}
                      ></TextField>
                    </FormControl>
                  </div>
                  <div className='field'>
                    Text Grey
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        className='airport_name'
                        labelId='size'
                        type='color'
                        id='demo-simple-select'
                        value={editTextGrey}
                        onChange={(e) => setEditTextGrey(e.target.value)}
                      ></TextField>
                    </FormControl>
                  </div>
                </div>
                <div className='info_row '>
                  <div className='field'>
                    Primary Shadow
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        className='airport_name'
                        labelId='size'
                        type='color'
                        id='demo-simple-select'
                        value={editPrimaryBoxShadow}
                        onChange={(e) => setPrimaryBoxShadow(e.target.value)}
                      ></TextField>
                    </FormControl>
                  </div>
                  <div className='field'>
                    Secondary Shadow
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        className='airport_name'
                        labelId='size'
                        type='color'
                        id='demo-simple-select'
                        value={editSecondaryBoxShadow}
                        onChange={(e) => setSecondaryBoxShadow(e.target.value)}
                      ></TextField>
                    </FormControl>
                  </div>
                </div>
                <div className='info_row '>
                  <div className='field'>
                    Primary Border Color
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        className='airport_name'
                        labelId='size'
                        type='color'
                        id='demo-simple-select'
                        value={editPrimaryBorderColor}
                        onChange={(e) => setPrimaryBorderColor(e.target.value)}
                      ></TextField>
                    </FormControl>
                  </div>
                  <div className='field'>
                    Backdrop
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        className='airport_name'
                        labelId='size'
                        id='demo-simple-select'
                        type='color'
                        value={editBackDrop}
                        onChange={(e) => setEditBackDrop(e.target.value)}
                      ></TextField>
                    </FormControl>
                  </div>
                </div>
                <div className='info_row '>
                  <div className='field'>
                    Primary BG
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        className='airport_name'
                        labelId='size'
                        type='color'
                        id='demo-simple-select'
                        value={editPrimaryBG}
                        onChange={(e) => setEditPrimaryBG(e.target.value)}
                      ></TextField>
                    </FormControl>
                  </div>
                  <div className='field'>
                    LightBlue
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        className='airport_name'
                        labelId='size'
                        id='demo-simple-select'
                        type='color'
                        value={editLightBlue}
                        onChange={(e) => setEditLightBlue(e.target.value)}
                      ></TextField>
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className='btns'>
                <button
                  className='primary'
                  onClick={(e) =>
                    selectedRow ? handleUpdateTheme(e) : handleCreateTheme(e)
                  }
                >
                  Save
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
}
